<template>
  <div>
    <v-row no-gutters align="center" class="mb-4">
      <v-col cols="12" sm="6" class="text-start">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("user.registration.recentRegistrations") }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" class="text-end" v-if="havePermissionCreateTrainingRegistration">
        <v-btn
          depressed
          color="primary"
          style="text-transform: unset"
          class="rounded-lg font-weight-normal"
          @click="$router.push({ name: 'Registration' })"
        >
          <vue-feather type="user-plus" size="14" class="me-1" />
          {{ $t("course.registration") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <registration-list
          :datas="registrationsData"
          :loading="loading"
          @reFetch="refetch"
        />
      </v-col>

      <v-col cols="12" v-if="registrationsData && registrationsData.length">
        <div class="d-flex justify-end textLight--text subtitle-2">
          <p
            class="ma-0"
            style="cursor: pointer"
            @click="$router.push({ name: 'Registrations' })"
          >
            {{ $t("user.registration.viewAll") }}
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RegistrationList from "./RegistrationsList.vue";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  data() {
    return {
      registrationsData: [],
      search: null,
      loading: false,
    };
  },
  components: {
    RegistrationList,
  },
  computed: {
    havePermissionCreateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: {
          limit: 10,
          skip: 0,
        },
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.registrationsData =
              data.getTrainingRegistrations.trainingRegistrations.slice(0, 3);
          }

          this.loading = loading;
        },
      };
    },
  },
  created() {
    this.$apollo.queries.getTrainingRegistrations.refetch();
  },
  watch: {
    search() {
      this.$apollo.queries.getTrainingRegistrations.refetch({
        filterInput: {
          search: this.search,
        },
      });
    },
  },
  methods: {
    async refetch() {
      this.$apollo.queries.getTrainingRegistrations.refetch();
    },
  },
};
</script>
